module.exports = __webpack_public_path__ + "static/media/main_background.613b7c80.png";